import type { StoreVariant } from "replo-runtime/shared/types";

export function stripHtmlTags(html: string): string {
  if (!html) {
    return "";
  }
  // NOTE (Matt 2025-04-15): This logic is useful for ensuring we are removing
  // encoded html tags (ex:  "&lt;span class=\"money\"&gt;${{amount}}&lt;/span&gt;")
  const textarea = document.createElement("textarea");
  textarea.innerHTML = html;
  return textarea.value.replace(/<[^>]*>/g, "");
}

/**
 * @returns A string representation of the variant's options
 */
export function getVariantLabel(variant: StoreVariant): string {
  return `${variant.option1}${
    variant.option2 ? ` / ${variant.option2}` : ""
  }${variant.option3 ? ` / ${variant.option3}` : ""}`;
}
